// extracted by mini-css-extract-plugin
export const ourMotivation = "our-motivation-module--ourMotivation--33Uj2";